module.exports = __webpack_public_path__ + "img/photo3.d63bb8b9.jpg";